import { includesSome } from "../utils/utils"
import useLoaderData from "./useLoaderData"

export default function useMe () {
  const { userId, permissions = '', source, isVerified } = useLoaderData()

  const APP_PERMISSIONS = [
    'JOBS_READ',
    'JOBS_EDIT',
  ];

  return { 
    userId,
    permissions,
    source,
    isVerified,
    hasAppAccess: APP_PERMISSIONS.some((perm) => permissions?.includes(perm)),
    hasRead: includesSome(permissions, ['JOBS_READ']),
    hasEdit: includesSome(permissions, ['JOBS_EDIT']),
  }
}